import { getReq, postReq } from "./network/request.js";

//#####··········GET相关··········#####//
//#####··········POST相关··········#####//
//####········上传········####//
export const news = (data, other) => {
  return postReq("/api/site/news", data, other);
};

export const newss = (id) => {
  return getReq(`/api/site/news/${id}`);
};
export const detail = (id) => {
  return getReq(`/site/${id}`);
};

export const MenuList = (data, other) => {
  return postReq("/api/site/menu", data, other);
};

//
export const getNames = (id) => {
  return getReq(`/api/cate/${id}`);
};